import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex)

import AuthModule, { getDecodedValueFromLS } from './modules/auth_modules';
import RoleModule from './modules/role_module';
import NotiModule from './modules/noti_modules';
import globalvariables from '../globalvariables';

if (localStorage.token) {
  const token = getDecodedValueFromLS(globalvariables.LS_TOKEN_KEY_NAME, 'string')
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  axios.defaults.headers.common['Accept'] = 'application/json';
  axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_DEV_KEY;
  //React Example:  store.dispatch( setCurrentUser (JSON.parse(localStorage.userData)) ); // Soooooo vital...
}
axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  // Do something with response error
  console.log('checking incterceptor');
  if (error.response.status === 401) {
      console.log('unauthorized, logging out ...');
      store.dispatch('auth/logout')
              .then(result => {
                window.location.href = 'login'
                console.log('logout :: ');
              })
              .catch(error => {
                console.log('logout failure :: ', error.response);
                window.location.href = 'login'
              })
     
  }
  return Promise.reject(error.response);
});

const store = new Vuex.Store({
  strict: true,
  modules: {
    auth: AuthModule,
    role: RoleModule,
    noti: NotiModule,

  },
  state : {
    sidebarShow: 'responsive',
    sidebarMinimize: false
  },

   mutations : {
    toggleSidebarDesktop (state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile (state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set (state, [variable, value]) {
      state[variable] = value
    }
  }

})

console.log('Access Token === ', store.getters.auth);

export default store;
